import React, {useState, useEffect} from 'react'
import {Link} from 'gatsby'
import {
	Container,
	Grid,
	Header,
	Icon,
	Image,
	List,
	Segment,
} from 'semantic-ui-react'
import * as styles from './footer.module.css'
import {
	mobileMaxWidth,
} from '../../globalVar'

import ChatIcon from '../chaticon'
import IamnetConsent from '../iamnetconsent'

const Footer = ({location}) => {
	const [textAlign,setTextAlign] = useState(null)
	const date = new Date()

	function textAlignAdjust() {
		if(window.innerWidth >= mobileMaxWidth  ) {
			setTextAlign(null)
		}
		if(window.innerWidth < mobileMaxWidth  ) {
			setTextAlign("center")
		}
	}
	useEffect(()=>{
		textAlignAdjust()
		window.addEventListener("resize", textAlignAdjust)
		return () => {
			window.removeEventListener("resize", textAlignAdjust)
		}
	}, [])
	return(
		<Segment
			vertical
			className={styles.segment}
		>
			<Container>
				<Grid stackable textAlign={textAlign}>
					<Grid.Row >
						<Grid.Column width={4} >
							<Header
								content="About"
								className={styles.header}
							/>
							<List>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/faq">
											FAQ
										</Link>
									</List.Content>

								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/privacy/">
											Privacy Policy
										</Link>
									</List.Content>

								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/terms/" >
											Terms & Conditions
										</Link>
									</List.Content>

								</List.Item>
							</List>
						</Grid.Column>
						<Grid.Column width={4}>
							<Header
								content="Services"
								className={styles.header}
							/>
							<List>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/franchise/" >
											Franchise
										</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/category/" >
											Products
										</Link>
									</List.Content>
								</List.Item>

								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/faq/#Cash-Upon-Delivery" >
											Cash on Delivery
										</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/pick-up-transactions/" >
											Pick up Transactions
										</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/pick-up-transactions/#bus-shipping" >
											Bus Shipping
										</Link>
									</List.Content>
								</List.Item>
							</List>
						</Grid.Column>
						<Grid.Column width={4}>
							<Header
								content="Resources"
								className={styles.header}
							/>
							<List>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/seminar/" >
											Seminars
										</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/course/" >
											Courses
										</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/recipes/" >
											Recipes and Videos
										</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/stories/" >
											Stories and Tips
										</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/howto/" >
											How-To Guides
										</Link>
									</List.Content>
								</List.Item>
							</List>
						</Grid.Column>
						<Grid.Column width={4}>
							<Header
								content="Contact Us"
								className={styles.header}
							/>
							<List>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/payment/" >
											Submit Order Payment
										</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
										<Link to="/confirm/" >
											Confirm Your Order
										</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
									<Link to="/request-product/" >
										Request a Product
									</Link>
									</List.Content>
								</List.Item>
								<List.Item
									className={`${styles.text} ${styles.columnItems}`}
								>
									<List.Content>
									inquiries@negosyonow.com
									</List.Content>
								</List.Item>
								<List.Item className={`${styles.text} ${styles.columnItems}`}>
									+639176218246
								</List.Item>
								<List.Item className={`${styles.text} ${styles.columnItems}`}>
									704 Rizal Ave. ext.<br/>
									Caloocan City, Metro Manila<br/>
									Philippines, 1403
								</List.Item>
							</List>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column width={11}>
							<List horizontal >
								<List.Item>
									<Header className={styles.text}>
										Connect With Us
									</Header>
								</List.Item>
								<List.Item
									as="a"
									target="_blank"
									href="https://www.facebook.com/negosyonow"
									alt="Facebook"
									title="NegosyoNow Facebook"
								>
									<Image src='https://cdn.ngnw.ph/images/asset/icons/social/icon_fb_green1.png' avatar alt='Facebook' className={styles.socialMediaIcon} />
								</List.Item>
								<List.Item
									as="a"
									target="_blank"
									href="https://www.youtube.com/negosyonow"
									alt="Youtube"
									title="NegosyoNow Youtube"
								>
									<Image src='https://cdn.ngnw.ph/images/asset/icons/social/icon_youtube_green1.png' alt='Youtube' avatar className={styles.socialMediaIcon} />
								</List.Item>
								<List.Item
									as="a"
									target="_blank"
									href="https://instagram.com/negosyonow"
									alt="Instagram"
									title="NegosyoNow Instagram"
								>
									<Image src='https://cdn.ngnw.ph/images/asset/icons/social/icon_ig_green1.png' avatar alt='Instagram' className={styles.socialMediaIcon} />
								</List.Item>
								<List.Item
									as="a"
									target="_blank"
									href="https://twitter.com/negosyonowcom"
									alt="Twitter"
									title="NegosyoNow Twitter"
								>
									<Image src='https://cdn.ngnw.ph/images/asset/icons/social/icon_twitter_green1.png' avatar alt='Twitter' className={styles.socialMediaIcon} />
								</List.Item>
								<List.Item
									as="a"
									target="_blank"
									href="https://tiktok.com/@negosyonow"
									alt="Tiktok"
									title="NegosyoNow Tiktok"
								>
									<Image src='https://cdn.ngnw.ph/images/asset/icons/social/icon_tiktok_green1.png' avatar alt='Twitter' className={styles.socialMediaIcon} />
								</List.Item>

							</List>
						</Grid.Column>
						<Grid.Column width={5} className={styles.text}>
							© {date.getFullYear()} negosyonow.com
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Container>
			<ChatIcon />
			<IamnetConsent location={location} />
		</Segment>
	)
}

export default Footer
